import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { BaseAddressModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { PaginationPresentationProps } from "@insite/mobius/Pagination";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import React, { useEffect, useState } from "react";
import ADICustomerCard, { ADICustomerCardStyles } from "./ADICustomerCard";

interface OwnProps {
    customers: BaseAddressModel[];
    pagination: PaginationModel | null;
    selectedCustomer?: BaseAddressModel;
    onSelect: (customer: BaseAddressModel) => void;
    /** @deprecated Not used anymore */
    allowEditCustomer?: boolean;
    onEdit?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, customer: BaseAddressModel) => void;
    onChangePage: (page: number) => void;
    onChangeResultsPerPage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    extendedStyles?: ADICustomerSelectorStyles;
    isSearchClicked?: boolean;
}

export interface ADICustomerSelectorStyles {
    customerCard?: ADICustomerCardStyles;
    customerCardSelected?: ADICustomerCardStyles;
    pagination?: PaginationPresentationProps;
}

const linkTextStyles: TypographyPresentationProps = {
    color: "text.link",
};

export const adiCustomerSelectorStyles: ADICustomerSelectorStyles = {
    customerCardSelected: {
        address: {
            attentionText: linkTextStyles,
            customerNameText: linkTextStyles,
            companyNameText: linkTextStyles,
            address1Text: linkTextStyles,
            address2Text: linkTextStyles,
            address3Text: linkTextStyles,
            address4Text: linkTextStyles,
            cityStatePostalCodeText: linkTextStyles,
            countryText: linkTextStyles,
            phoneText: linkTextStyles,
            emailText: linkTextStyles,
            faxText: linkTextStyles,
        },
    },
};

const ADICustomerSelector = ({ customers, extendedStyles, selectedCustomer, onSelect, onEdit, isSearchClicked }: OwnProps) => {
    const [styles] = useState(() => mergeToNew(adiCustomerSelectorStyles, extendedStyles));
    const [filteredAndExcludedCustomers, setFilteredAndExcludedCustomers] = useState<BaseAddressModel[]>([]);

    const filteredCustomers = customers.filter(customer => customer.uri !== null);

    const indexOfFalse = filteredCustomers.findIndex(customer => customer.properties.isDropShip === "False");

    useEffect(() => {
        if (isSearchClicked) {
            setFilteredAndExcludedCustomers(filteredCustomers.slice(0))
        }
        else {
            const customerList = indexOfFalse === 0 ? filteredCustomers.slice(1) : filteredCustomers;
            setFilteredAndExcludedCustomers(customerList)
        }
    }, [customers])

    return (
        <>
            {filteredAndExcludedCustomers.map(customer => {
                const isCardSelected = customer.id === selectedCustomer?.id;
                return (
                    <ADICustomerCard
                        key={customer.id}
                        customer={customer}
                        isSelected={isCardSelected}
                        extendedStyles={isCardSelected ? styles.customerCardSelected : styles.customerCard}
                        onSelect={onSelect}
                        onEdit={onEdit}
                    />
                );
            })}
        </>
    );
};

export default ADICustomerSelector;
